<!-- <div class="fw-bold border-bottom mb-3 sticky-top bg-white p-3">
<h5 class="fs-14 m-0">{{ 'COMMON.FILTERS' | translate }}</h5>
</div>-->

<div class="mt-3 ">
  <!-- <ngx-simplebar class="h-100"> -->
  @if (filterFields && filterFields.length > 0) {
  <form [formGroup]="filtersForm">
    <div class="row g-2">
      @for (filter of filterFields; track filter.fieldName; let id = $index) {
      <div class="col-sm-6 col-lg-4 col-xl-2">
        @if ((filter.dataType == 'DATE_TIME') || (filter.dataType == 'DATE')) {
        <div class="form-floating input-group">
          <input title="time" class="form-control" [plugins]="plugins"
            (ngModelChange)="updateDateFilterControl(filter.dataType,$event,filter.fieldName)" [dateFormat]="'Y-m-d'"
            formControlName="{{ filter.fieldName }}" type="text" mwlFlatpickr [enableTime]="false"
            [placeholder]="_translate.currentLang == 'en'? filter.placeHolderEn: filter.placeHolderAr"
            id="isDate{{filter.fieldName}}">
          <label class="form-label mb-0">
            {{ _translate.currentLang == 'en'? filter.placeHolderEn: filter.placeHolderAr }}
          </label>
          <div class="input-group-text text-primary">
            <i class="ri-calendar-2-line"></i>
          </div>
        </div>
        }
        <!-- <div *ngIf="filter.dataType === 'DATE'" class="form-floating input-group">
              <input class="form-control bg-white border-gray" [plugins]="plugins"
                (ngModelChange)="updateFilterControl(filter.dataType,$event,filter.fieldName)" [dateFormat]="'Y-m-d'"
                formControlName="{{ filter.fieldName }}" type="text" mwlFlatpickr [enableTime]="false"
                [placeholder]="_translate.currentLang == 'en'? filter.placeHolderEn: filter.placeHolderAr">
                <label class="form-label mb-0 ">
                  {{ _translate.currentLang == 'en'? filter.placeHolderEn: filter.placeHolderAr }}
                </label>
                <div class="input-group-text text-primary">
                  <i class="ri-calendar-2-line"></i>
                </div>
              </div> -->
        @if (!enableOnlyDateRange) {
        <div>
          @if (filter.dataType === 'DECIMAL_NUMBER') {
          <div class="form-floating">
            <input title="updateFilterControl" class="form-control" (change)="updateFilterControl(filter.fieldName)"
              formControlName="{{ filter.fieldName }}" type="text" mask="separator.2" thousandSeparator=","
              [placeholder]="_translate.currentLang == 'en'? filter.placeHolderEn: filter.placeHolderAr">
            <label class="form-label mb-0 ">
              {{ _translate.currentLang == 'en'? filter.placeHolderEn: filter.placeHolderAr }}
            </label>
          </div>
          }
          @if (filter.dataType === 'BOOLEAN') {
          <div class="form-floating">
            <div class="d-flex flex-column gap-2 mb-1">
              <div class="form-check form-radio-outline form-radio-dark mb-2">
                <input class="form-check-input" type="checkbox"
                  (change)="onCheckboxChanged( filter , filter.fieldName , $event )"
                  formControlName="{{ filter.fieldName }}" id="{{filter.fieldName}}">
                <label class="form-check-label" for="{{filter.fieldName}}">
                  {{ _translate.currentLang == 'en'? filter.placeHolderEn: filter.placeHolderAr }}
                </label>
              </div>
            </div>
            <label class="form-label mb-0">
              {{ _translate.currentLang == 'en'? filter.placeHolderEn: filter.placeHolderAr }}
            </label>
          </div>
          }
          @if (filter.dataType === 'SELECT') {
          <div class="mb-1 form-floating">
            <!-- <div class="d-flex flex-column mb-1"
                          *ngFor="let subFilter of filter.selectValues | slice:0:filter.maxViewedOptionsCount; let i = index">
                          <div class="form-check form-radio-outline form-radio-dark mb-2">
                            <input class="form-check-input" type="radio" [value]="subFilter.value"
                              (change)="onRadioboxChange(subFilter,filter.fieldName)"
                              formControlName="{{ filter.fieldName }}" id="{{filter.fieldName+i}}">
                              <label class="form-check-label" for="{{filter.fieldName+i}}">
                                {{ _translate.currentLang == 'en'? subFilter.valueEn: subFilter.valueAr }}
                              </label>
                            </div>
                          </div> -->
            <ng-select formControlName="{{ filter.fieldName }}" [clearable]="true" bindLabel="valueEn"
              (change)="onSelectChanged($event,filter?.fieldName)"
              [class.has-value]="filtersForm.get(filter.fieldName).value">
              @for (subFilter of filter.selectValues; track subFilter.id || subFilter.value) {
              <ng-option [value]="subFilter">
                {{ _translate.currentLang == 'en'? subFilter?.valueEn: subFilter?.valueAr }}
              </ng-option>
              }
            </ng-select>
            <label class="form-label mb-0">
              {{ _translate.currentLang == 'en'? filter.filterLabelEn: filter.filterLabelAr }}
            </label>
          </div>
          }
          <!-- <div *ngIf="filter.dataType === 'MULTI_SELECT' && filter.selectValues.length > 0"
                      [formGroupName]="filter.fieldName">
                      <div class="d-flex flex-column mb-1"
                        *ngFor="let subFilter of filter.selectValues | slice:0:filter.maxViewedOptionsCount; let i = index;">
                        <div class="form-check form-radio-outline form-radio-dark mb-2">
                          <input class="form-check-input" type="checkbox" [value]="subFilter.value || 0"
                            (change)="onCheckboxChanged(subFilter,filter.fieldName,$event)"
                            [formControlName]="subFilter.value" id="{{filter.fieldName + i}}">
                            <label class="form-check-label" for="{{filter.fieldName+i}}">
                              {{ _translate.currentLang == 'en'? subFilter.valueEn: subFilter.valueAr }}
                            </label>
                          </div>
                        </div>
                      </div> -->
          @if (filter.dataType === 'MULTI_SELECT') {
          <div class="mb-1 form-floating">
            <ng-select formControlName="{{ filter.fieldName }}" [clearable]="true" bindLabel="valueEn"
              (change)="onSelectChanged($event,filter?.fieldName)" [multiple]="true"
              [class.has-value]="filtersForm.get(filter.fieldName).value">
              @for (subFilter of filter.selectValues; track subFilter.id || subFilter.value) {
              <ng-option [value]="subFilter">
                @if (filter.fieldName == 'transactionCategoty') {
                <div class="d-flex align-items-center lh-1">
                  @if (subFilter.additionalAttributes[0].value === 'IN_FLOW' && subFilter.additionalAttributes[1].value
                  !== 'true') {
                  <div class="wh-16">
                    <img src="/assets/images/svg/icon-cash-inflow.svg" alt="icon cash inflow" class="wh-16" />
                  </div>
                  }
                  @if (subFilter.additionalAttributes[0].value === 'OUT_FLOW' && subFilter.additionalAttributes[1].value
                  !== 'true') {
                  <div class="wh-16">
                    <img src="/assets/images/svg/icon-cash-outflow.svg" alt="icon cash outflow" class="wh-16" />
                  </div>
                  }
                  <span
                    [innerHTML]="(_translate.currentLang !== 'en' && !subFilter.valueAr) ? subFilter.valueEn : (_translate.currentLang === 'en' ? subFilter.valueEn : subFilter.valueAr)"
                    [class.ps-1]="subFilter.additionalAttributes[1].value !== 'true'"
                    [class.fw-bold]="subFilter.additionalAttributes[1].value !== 'true'"
                    [class.ps-3]="subFilter.additionalAttributes[1].value === 'true'"></span>
                </div>
                }
                @if (filter.fieldName !== 'transactionCategoty') {
                <span>
                  {{_translate.currentLang == 'en'? subFilter?.valueEn : subFilter?.valueAr}}
                </span>
                }
              </ng-option>
              }
            </ng-select>
            <label class="form-label mb-0">
              {{ _translate.currentLang == 'en'? filter.filterLabelEn : filter.filterLabelAr }}
            </label>
          </div>
          }
        </div>
        }
      </div>
      }
    </div>
  </form>
  }
  <!-- </ngx-simplebar> -->
</div>
<!--end offcanvas-body-->
<div class="hstack gap-3 bg-white mt-3 justify-content-end">
  <button type="button" class="btn btn-secondary btn-sm" (click)="resetFilters()">
    {{ 'COMMON.RESET' | translate }}
  </button>
  <button class="btn btn-primary btn-sm" (click)="submitFilter()">
    {{ 'COMMON.APPLY' | translate }}
  </button>
</div>